import axios from 'axios'
import { api_lp, api } from '@/services/config'
import store from '@/store'
import { mixin } from '@/mixins/helper'
import router from '../../router'

const k3lStore = {
  namespaced: true,
  state: () => ({
    is_vendor_done: true,
    for_test: true,
    is_sipm_approved: false,
    is_oc_submit: false,
    is_k3l_done: false,
    is_preview: false,
    // modal in K3L
    modal_add_kbli: false,
    modal_add_perusahaan: false,
    modal_add_induk_perusahaan: false,
    modal_add_perizinan: false,
    modal_add_iujp: false,
    modal_add_iujp_non_inti: false,
    modal_add_competencies: false,
    modal_add_golden_rules: false,
    modal_add_sistem_manajemen: false,
    //
    register_step: true,
    profile_step: true,
    dokumentasi_step: true,
    grup13_step: true,
    grup46_step: true,
    grup78_step: true,
    end_step: true,
    registerDone: true,

    globalLoading: false,
    activeLanding: process.env.VUE_APP_K3L_ACTIVE_LANDING,

    user_id: null,
    request_id: null,
    vendor_ref: null,
    phone_code: null,
    mata_uang: null,
    pendaftaran_id: null,
    tujuan_pendaftaran_id: null,
    bidang_usaha_id: null,
    type_pendaftaran_id: null,

    k3l_vendor_name: '',
    k3l_tanggal_berdiri: '',
    k3l_alamat: '',
    choosed_country: [],
    choosed_province: [],
    choosed_city: [],
    choosed_distric: [],
    choosed_village: [],
    kodepos: '',
    k3l_choosed_bu: '',
    k3l_email: '',

    companies_edit: false,
    companies_add: false,
    companies_index: 0,
    companies_id: 0,
    companies_name: '',
    companies_contact: '',
    companies_position: '',
    companies_phone: '',
    companies_email: '',
    child_companies: [],
    parent_companies: [],

    k3l_pic_name: '',
    k3l_pic_position: '',
    k3l_pic_email: '',
    k3l_pic_phone: '',
    k3l_pic_phone_code: '',
    addedKbli: [],
    addedPerizinan: [],
    addedIUJP: [],
    addedIUJPnonInti: [],
    structurOrgFile: '',

    skill_edit: false,
    skill_add: false,
    skill_index: 0,
    skill_id: 0,
    skill_position: '',
    skill_total_employee: '',
    skill_competencies: '',
    skill_exp: '',
    skill_doc: '',
    addedCompetencies: [],

    location_1: 0,
    location_2: 0,
    location_3: 0,
    // grup1-3
    textGrup1: '',
    kebijakanFile: '',
    buktiKebijakanFile: '',
    textGrup2: '',
    hiraFile: '',
    policyFile: '',
    textGrup22: '',
    riskFile: '',
    implementasiRiskFile: '',
    textGrup3: '',
    manualFile: '',
    implementasiManual: '',
    // grup4-6
    textGrup4: '',
    prosedurB3: '',
    programB3: '',
    implementasiB3: '',
    textGrup5: '',
    prosedurLimbah: '',
    programLimbah: '',
    buktiPengelolaanLimbah: '',
    implementasiLimbah: '',
    addedGoldenRules: [],
    programFatalPrevention: '',
    programFatalPrevention: '',
    sosialisasiFatalPrevention: '',
    implementasiFatalPrevention: '',
    dokumenKerjaFatalPrevention: '',
    implementasiDokumenKerjaFatalPrevention: '',
    evaluasiFatalPrevention: '',
    // group 7-8
    manage_edit: false,
    manage_add: false,
    manage_index: 0,
    manage_id: 0,
    manage_audit: '',
    manage_pihak_ketiga: '',
    manage_masa_berlaku: '',
    manage_tgl_efektif: '',
    manage_tgl_berakhir: '',
    manage_sertifikat: '',
    addedSistemManajemen: [],
    daftarDokumenKerja: '',
    dokumenKerja: '',
    pemeriksaanImpelentasiDokumenKerja: '',
    textGroup8: '',
    statistikKinerjaK3L: '',
    textGroup82: '',
    penyelidikanKecelakaan: '',

    //penilaian
    izin_11: '',
    izin_12: '',
    note_izin_11: '',
    note_izin_12: '',

    sertifikat_11: '',
    sertifikat_12: '',
    sertifikat_13: '',
    note_sertifikat_11: '',
    note_sertifikat_12: '',
    note_sertifikat_13: '',

    penilaian_grup1_11: '',
    note_grup1_11: '',

    penilaian_grup2_11: '',
    penilaian_grup2_12: '',
    note_grup2_11: '',
    note_grup2_12: '',

    penilaian_grup3_11: '',
    note_grup3_11: '',

    penilaian_grup4_11: '',
    note_grup4_11: '',

    penilaian_grup5_11: '',
    note_grup5_11: '',

    penilaian_grup6_11: '',
    penilaian_grup6_12: '',
    note_grup6_11: '',
    note_grup6_12: '',

    penilaian_grup7_11: '',
    penilaian_grup7_12: '',
    note_grup7_11: '',
    note_grup7_12: '',

    penilaian_grup8_11: '',
    note_grup8_11: '',

    rating_result_1: 0,
    rating_result_2: 0,
    rating_result_3: 0,
    total_result: 0,

    bobot_1_1: 25,
    bobot_1_2: 75,

    bobot_2_1: 33.33,
    bobot_2_2: 33.33,
    bobot_2_3: 33.33,

    bobot_3_1: 0,
    bobot_3_2: 0,
    bobot_3_3: 0,
    bobot_3_4: 0,
    bobot_3_5: 0,
    bobot_3_6: 0,
    bobot_3_7: 0,
    bobot_3_8: 0,
    bobot_3_9: 0,
    bobot_3_10: 0,
    bobot_3_11: 0,

    value_1_1: 0,
    value_1_2: 0,

    value_2_1: 0,
    value_2_2: 0,
    value_2_3: 0,

    value_3_1: 0,
    value_3_2: 0,
    value_3_3: 0,
    value_3_4: 0,
    value_3_5: 0,
    value_3_6: 0,
    value_3_7: 0,
    value_3_8: 0,
    value_3_9: 0,
    value_3_10: 0,
    value_3_11: 0,
  }),
  mutations: {
    SET_ACTIVE_PAGE(state, payload) {
      state.activeLanding = payload.name
    },
    SET_K3L_FORM(state, payload) {
      state[payload.name] = payload.value
    },
    SET_SERTIFIKAT_KARYAWAN(state, payload) {
      state.skill_id = payload.id
      state.skill_position = payload.posisi
      state.skill_total_employee = payload.jumlah
      state.skill_competencies = payload.umum_khusus
      state.skill_exp = payload.pengalaman_kerja
      state.skill_doc = payload.sertifikat_karyawan
    },
    SET_SISTEM_MANAJEMEN(state, payload) {
      state.manage_id = payload.id
      state.manage_audit = payload.lingkup_audit
      state.manage_pihak_ketiga = payload.third_party
      state.manage_masa_berlaku = payload.masa_berlaku
      state.manage_tgl_efektif = payload.tgl_efektif
      state.manage_tgl_berakhir = payload.tgl_berakhir
      state.manage_sertifikat = payload.sertifikasi
    },
    async UPDATE_INFORMASI(state, info) {
      if (info) {
        state.k3l_vendor_name = await info.nama_vendor
        state.k3l_choosed_bu = await mixin.methods.$get(
          info,
          'badan_usaha.desc'
        )
        state.k3l_tanggal_berdiri = await mixin.methods.formatDateInput(
          info.tanggal_berdiri
        )

        let storeKbli = []
        for (let i in info.kbli) {
          let newKbli = await info.kbli[i].kbli_sub
          newKbli['nib'] = await info.kbli[i].nib
          newKbli['ss_izin'] = await info.kbli[i].ss_izin
          newKbli['dokumen_lainnya'] = await info.kbli[i].dokumen_lainnya

          storeKbli.push(newKbli)
        }
        state.addedKbli = storeKbli

        if (info.iujp && info.iujp.length > 0) {
          let storeIujp = []
          for (let iujp in info.iujp) {
            let newIujp = await info.iujp[iujp].master_iujp
            if (newIujp) newIujp['checked'] = true
            storeIujp.push(newIujp)
          }
          state.addedIUJP = storeIujp
        }

        if (info.iujptl && info.iujptl.length > 0) {
          let storeIujptl = []
          for (let iujptl in info.iujptl) {
            let newIujptl = await info.iujptl[iujptl].master_iujptl
            if (newIujptl) newIujptl['checked'] = true
            storeIujptl.push(newIujptl)
          }
          state.addedIujptl = storeIujptl
        }

        if (info.sbujk && info.sbujk.length > 0) {
          let storeSbujk = []
          for (let sbujk in info.sbujk) {
            let newSbujk = await info.sbujk[sbujk].master_sbujk
            if (newSbujk) newSbujk['checked'] = true
            storeSbujk.push(newSbujk)
          }
          state.addedSbujk = storeSbujk
        }

        if (info.inu_bbm && info.inu_bbm.length > 0) {
          let storeInuBbm = []
          for (let inu_bbm in info.inu_bbm) {
            let newInuBbm = await info.inu_bbm[inu_bbm].master_inu_bbm
            if (newInuBbm) newInuBbm['checked'] = true
            storeInuBbm.push(newInuBbm)
          }
          state.addedInubbm = storeInuBbm
        }

        if (info.siupal && info.siupal.length > 0) {
          let storeSiupal = []
          for (let siupal in info.siupal) {
            let newSiupal = await info.siupal[siupal].master_siupal
            if (newSiupal) newSiupal['checked'] = true
            storeSiupal.push(newSiupal)
          }
          state.addedSiupal = storeSiupal
        }

        state.choosed_country = await info.negara
        state.choosed_province = await info.provinsi
        state.choosed_city = await info.kota
        state.choosed_distric = await info.kecamatan
        state.choosed_village = await info.kelurahan
        // state.kodepos = await mixin.methods.$get(info, 'kelurahan.kodepos')
        if (info.negara_id == 63) {
          state.kodepos = await mixin.methods.$get(info, 'kelurahan.kodepos')
        } else {
          state.kodepos = await info.kode_pos_asing
        }
        state.phoneNumber = await info.no_handphone
        state.k3l_email = await info.email
        state.k3l_alamat = info.alamat
        state.k3l_pic_phone_code = await mixin.methods.$get(
          info,
          'negara.kode_telepon'
        )
        state.phone_code = await mixin.methods.$get(info, 'negara.kode_telepon')
      }
    },
    async UPDATE_LEGAL(state, legal) {
      if (legal) {
        for (let i in legal) {
          legal[i] = {
            ...legal[i],
            id: legal[i].legal_document_id,
          }
        }
        state.allLegal = legal
        let akta = await legal.filter(i => i.type == 1)
        let komersial = await legal.filter(
          i => i.type == 2 && i.legal_document_id != 7
        )
        let perizinan = await legal.filter(i => i.type == 3)

        let activeAkta = await akta.filter(i => i.lampiran)
        let newAkta = []
        for (let i in activeAkta) {
          let tmp = activeAkta[i]
          tmp['id'] = activeAkta[i].legal_document_id
          tmp['checked'] = true
          tmp['keterangan'] = activeAkta[i].no_dokumen
          tmp['start_date'] = mixin.methods.formatDateInput(
            activeAkta[i].tanggal_efektif
          )
          tmp['end_date'] = mixin.methods.formatDateInput(
            activeAkta[i].tanggal_berakhir
          )
          tmp['fileName'] = activeAkta[i].lampiran

          newAkta.push(tmp)
        }
        state.addedAktaPerusahaan = newAkta

        let activeKomersial = await komersial.filter(i => i.lampiran)
        let newKomersial = []
        for (let i in activeKomersial) {
          let tmp = activeKomersial[i]
          tmp['id'] = activeKomersial[i].legal_document_id
          tmp['checked'] = true
          tmp['keterangan'] = activeKomersial[i].no_dokumen
          tmp['start_date'] = mixin.methods.formatDateInput(
            activeKomersial[i].tanggal_efektif
          )
          tmp['end_date'] = mixin.methods.formatDateInput(
            activeKomersial[i].tanggal_berakhir
          )
          tmp['fileName'] = activeKomersial[i].lampiran

          newKomersial.push(tmp)
        }
        state.addedKomersial = newKomersial

        let activePerizinan = await perizinan.filter(i => i.lampiran)
        let newPerizinan = []
        for (let i in activePerizinan) {
          let tmp = activePerizinan[i]
          tmp['id'] = activePerizinan[i].legal_document_id
          tmp['checked'] = true
          tmp['is_lifetime'] =
            activePerizinan[i].tanggal_efektif == null &&
            activePerizinan[i].tanggal_berakhir == null
              ? true
              : false
          tmp['keterangan'] = activePerizinan[i].no_dokumen
          tmp['start_date'] = mixin.methods.formatDateInput(
            activePerizinan[i].tanggal_efektif
          )
          tmp['end_date'] = mixin.methods.formatDateInput(
            activePerizinan[i].tanggal_berakhir
          )
          tmp['fileName'] = activePerizinan[i].lampiran

          newPerizinan.push(tmp)
        }
        state.addedPerizinan = newPerizinan

        let getLogoFileName = legal.filter(i => i.legal_document_id == 44)
        state.logoFileName = getLogoFileName && getLogoFileName[0].lampiran

        let getPaktaFileName = legal.filter(i => i.legal_document_id == 31)
        state.paktaFileName = getPaktaFileName && getPaktaFileName[0].lampiran

        let getFormulirFileName = legal.filter(i => i.legal_document_id == 32)
        state.formulirFileName =
          getFormulirFileName && getFormulirFileName[0].lampiran

        let getSuratFileName = legal.filter(i => i.legal_document_id == 7)
        state.suratFileName = getSuratFileName && getSuratFileName[0].lampiran

        let getKomitmenKplhFileName = legal.filter(
          i => i.legal_document_id == 33
        )
        state.komitmenKplhFileName =
          getKomitmenKplhFileName && getKomitmenKplhFileName[0].lampiran

        let getKtpFileName = legal.filter(i => i.legal_document_id == 27)
        state.ktpFileName = getKtpFileName && getKtpFileName[0].lampiran

        let getNpwpFileName = legal.filter(i => i.legal_document_id == 5)
        state.npwpFileName = getNpwpFileName && getNpwpFileName[0].lampiran

        let getKkFileName = legal.filter(i => i.legal_document_id == 28)
        state.kkFileName = getKkFileName && getKkFileName[0].lampiran

        let getCoverFileName = legal.filter(i => i.legal_document_id == 34)
        state.coverFileName =
          getCoverFileName &&
          getCoverFileName.length > 0 &&
          getCoverFileName[0].lampiran

        let getRekomendasiFileName = legal.filter(
          i => i.legal_document_id == 29
        )
        state.rekomendasiFileName =
          getRekomendasiFileName && getRekomendasiFileName[0].lampiran

        state.adaRekomendasi =
          getRekomendasiFileName && getRekomendasiFileName[0].lampiran
            ? true
            : false

        let getRekeningFileName = legal.filter(i => i.legal_document_id == 30)
        state.rekeningFileName =
          getRekeningFileName && getRekeningFileName[0].lampiran
        state.adaRekening =
          getRekeningFileName && getRekeningFileName[0].lampiran ? true : false
      }
    },
    SET_ARRAY_DATA(state, data) {
      if (data.operation == 'add') {
        state.companies_index = data.value.id
        state.skill_index = data.value.id
        state.manage_index = data.value.id
        state[data.name] = [...state[data.name], data.value]
      }

      if (data.operation == 'delete') {
        let filterData = state[data.name].filter(i => i.id !== data.value)
        state[data.name] = state[data.name].filter(i => i.id !== data.value)

        filterData.push(data.deleted)
        state[data.name] = filterData
      }

      if (data.operation == 'edit') {
        for (let i in state[data.name]) {
          if (state[data.name][i].id == data.value.id) {
            state[data.name][i]['id'] = data.value.id
            state[data.name][i]['name'] = data.value.name
            state[data.name][i]['contact'] = data.value.contact
            state[data.name][i]['position'] = data.value.position
            state[data.name][i]['phone'] = data.value.phone
            state[data.name][i]['email'] = data.value.email
          }
        }
      }

      state.companies_name = ''
      state.companies_contact = ''
      state.companies_position = ''
      state.companies_phone = ''
      state.companies_email = ''
      state.companies_edit = false
      state.companies_add = false

      state.skill_position = ''
      state.skill_total_employee = ''
      state.skill_competencies = ''
      state.skill_exp = ''
      state.skill_doc = ''

      state.manage_audit = ''
      state.manage_pihak_ketiga = ''
      state.manage_masa_berlaku = ''
      state.manage_tgl_efektif = ''
      state.manage_tgl_berakhir = ''
      state.manage_sertifikat = ''
    },
    SET_K3L_DETAIL(state, data) {
      // let regex = new RegExp(state.k3l_pic_phone_code)
      let isPhoneWithCode = false
      if (data && data.pic_phone_code) {
        state.k3l_pic_phone_code = data.pic_phone_code
        isPhoneWithCode = data.pic_phone.includes(data.pic_phone_code)
      }

      if (isPhoneWithCode) {
        state.k3l_pic_phone = data.pic_phone
      } else {
        state.k3l_pic_phone = state.k3l_pic_phone_code + ' ' + data.pic_phone
      }

      state.k3l_pic_name = data.pic_name
      state.k3l_pic_position = data.pic_position
      state.k3l_pic_email = data.pic_email

      state.textGrup1 = data.group_1_desc
      state.textGrup2 = data.group_2_desc
      state.textGrup22 = data.group_22_desc
      state.textGrup3 = data.group_3_desc
      state.textGrup4 = data.group_4_desc
      state.textGrup5 = data.group_5_desc
      state.textGroup8 = data.group_8_desc
      state.textGroup82 = data.group_82_desc
      state.addedGoldenRules = JSON.parse(data.golden_rules)
      state.addedIUJPnonInti = JSON.parse(data.non_inti)
      state.location_1 = data.fix_office_pkp2b
      state.location_2 = data.fix_office_berau
      state.location_3 = data.fix_office_indo
    },
    SET_K3L_PENILAIAN(state, data) {
      state.izin_11 = data.izin_11
      state.izin_12 = data.izin_12
      state.note_izin_11 = data.note_izin_11
      state.note_izin_12 = data.note_izin_12
      state.sertifikat_11 = data.sertifikat_11
      state.sertifikat_12 = data.sertifikat_12
      state.sertifikat_13 = data.sertifikat_13
      state.note_sertifikat_11 = data.note_sertifikat_11
      state.note_sertifikat_12 = data.note_sertifikat_12
      state.note_sertifikat_13 = data.note_sertifikat_13
      state.penilaian_grup1_11 = data.penilaian_grup1_11
      state.note_grup1_11 = data.note_grup1_11
      state.penilaian_grup2_11 = data.penilaian_grup2_11
      state.penilaian_grup2_12 = data.penilaian_grup2_12
      state.note_grup2_11 = data.note_grup2_11
      state.note_grup2_12 = data.note_grup2_12
      state.penilaian_grup3_11 = data.penilaian_grup3_11
      state.note_grup3_11 = data.note_grup3_11
      state.penilaian_grup4_11 = data.penilaian_grup4_11
      state.note_grup4_11 = data.note_grup4_11
      state.penilaian_grup5_11 = data.penilaian_grup5_11
      state.note_grup5_11 = data.note_grup5_11
      state.penilaian_grup6_11 = data.penilaian_grup6_11
      state.penilaian_grup6_12 = data.penilaian_grup6_12
      state.note_grup6_11 = data.note_grup6_11
      state.note_grup6_12 = data.note_grup6_12
      state.penilaian_grup7_11 = data.penilaian_grup7_11
      state.penilaian_grup7_12 = data.penilaian_grup7_12
      state.note_grup7_11 = data.note_grup7_11
      state.note_grup7_12 = data.note_grup7_12
      state.penilaian_grup8_11 = data.penilaian_grup8_11
      state.note_grup8_11 = data.note_grup8_11
    },
    CALCULATION_1(state, data) {
      let max_value = 20
      let bobot_1 = 0.25
      let bobot_2 = 0.75
      let item_1 = state.izin_11
      let item_2 = state.izin_12
      let value_1 = 0
      let value_2 = 0

      if (item_1 == 'N/A') {
        bobot_1 = 0
        bobot_2 = 1
        item_1 = 0
      }

      if (state.izin_12 == 'N/A') {
        bobot_1 = 1
        bobot_2 = 0
        item_2 = 0
      }

      state.bobot_1_1 = bobot_1 > 0 ? (bobot_1 * 100).toFixed(2) + '%' : '0 %'
      state.bobot_1_2 = bobot_2 > 0 ? (bobot_2 * 100).toFixed(2) + '%' : '0 %'

      value_1 = Math.round(max_value * (Number(item_1) / 5) * bobot_1)
      value_2 = Math.round(max_value * (Number(item_2) / 15) * bobot_2)

      state.value_1_1 = bobot_1 > 0 ? value_1.toFixed(2) : 'N/A'
      state.value_1_2 = bobot_2 > 0 ? value_2.toFixed(2) : 'N/A'

      let total = value_1 + value_2

      state.rating_result_1 = Math.round(total)

      let grand_total =
        total + Number(state.rating_result_2) + Number(state.rating_result_3)
      state.total_result = Math.round(grand_total)
    },
    CALCULATION_2(state, data) {
      let max_value = 15
      let bobot = 1
      let devider = 3
      let item_1 = state.sertifikat_11
      let item_2 = state.sertifikat_12
      let item_3 = state.sertifikat_13

      if (item_1 == 'N/A') {
        devider -= 1
        item_1 = 0
      }
      if (item_2 == 'N/A') {
        devider -= 1
        item_2 = 0
      }
      if (item_3 == 'N/A') {
        devider -= 1
        item_3 = 0
      }

      bobot = bobot / devider

      let value_1 = max_value * (Number(item_1) / 5) * Number(bobot)
      let value_2 = max_value * (Number(item_2) / 5) * Number(bobot)
      let value_3 = max_value * (Number(item_3) / 5) * Number(bobot)

      state.bobot_2_1 =
        state.sertifikat_11 != 'N/A' && item_1 >= 0
          ? (Number(bobot) * 100).toFixed(2) + '%'
          : '0 %'
      state.bobot_2_2 =
        state.sertifikat_12 != 'N/A' && item_2 >= 0
          ? (Number(bobot) * 100).toFixed(2) + '%'
          : '0 %'
      state.bobot_2_3 =
        state.sertifikat_13 != 'N/A' && item_3 >= 0
          ? (Number(bobot) * 100).toFixed(2) + '%'
          : '0 %'

      state.value_2_1 = state.bobot_2_1 != '0 %' ? value_1.toFixed(2) : 'N/A'
      state.value_2_2 = state.bobot_2_2 != '0 %' ? value_2.toFixed(2) : 'N/A'
      state.value_2_3 = state.bobot_2_3 != '0 %' ? value_3.toFixed(2) : 'N/A'

      let total = value_1 + value_2 + value_3

      state.rating_result_2 = Math.round(total)

      let grand_total =
        total + Number(state.rating_result_1) + Number(state.rating_result_3)
      state.total_result = Math.round(grand_total)
    },
    CALCULATION_3(state, data) {
      let max_value = 65
      let bobot = 0
      let alokasi_bobot = 0
      let bobot_1 = 0.077
      let bobot_2 = 0.154
      let bobot_3 = 0.154
      let devider = 11
      let item_1 = state.penilaian_grup1_11
      let item_2 = state.penilaian_grup2_11
      let item_3 = state.penilaian_grup2_12
      let item_4 = state.penilaian_grup3_11
      let item_5 = state.penilaian_grup4_11
      let item_6 = state.penilaian_grup5_11
      let item_7 = state.penilaian_grup6_11
      let item_8 = state.penilaian_grup6_12
      let item_9 = state.penilaian_grup7_11
      let item_10 = state.penilaian_grup7_12
      let item_11 = state.penilaian_grup8_11

      if (item_1 == 'N/A') {
        devider -= 1
        alokasi_bobot += bobot_1
        item_1 = 0
      }
      if (item_2 == 'N/A') {
        devider -= 1
        alokasi_bobot += bobot_1
        item_2 = 0
      }
      if (item_3 == 'N/A') {
        devider -= 1
        alokasi_bobot += bobot_1
        item_3 = 0
      }
      if (item_4 == 'N/A') {
        devider -= 1
        alokasi_bobot += bobot_1
        item_4 = 0
      }
      if (item_5 == 'N/A') {
        devider -= 1
        alokasi_bobot += bobot_1
        item_5 = 0
      }
      if (item_6 == 'N/A') {
        devider -= 1
        alokasi_bobot += bobot_1
        item_6 = 0
      }
      if (item_7 == 'N/A') {
        devider -= 1
        alokasi_bobot += bobot_1
        item_7 = 0
      }
      if (item_8 == 'N/A') {
        devider -= 1
        alokasi_bobot += bobot_2
        item_8 = 0
      }
      if (item_9 == 'N/A') {
        devider -= 1
        alokasi_bobot += bobot_1
        item_9 = 0
      }
      if (item_10 == 'N/A') {
        devider -= 1
        alokasi_bobot += bobot_3
        item_10 = 0
      }
      if (item_11 == 'N/A') {
        devider -= 1
        alokasi_bobot += bobot_1
        item_11 = 0
      }

      bobot_1 += devider == 0 ? 0 : alokasi_bobot / devider
      bobot_2 += devider == 0 ? 0 : alokasi_bobot / devider
      bobot_3 += devider == 0 ? 0 : alokasi_bobot / devider

      let value_1 = (
        max_value *
        (Number(item_1) / 5) *
        Number(bobot_1.toFixed(2))
      ).toFixed(2)
      let value_2 = (
        max_value *
        (Number(item_2) / 5) *
        Number(bobot_1.toFixed(2))
      ).toFixed(2)
      let value_3 = (
        max_value *
        (Number(item_3) / 5) *
        Number(bobot_1.toFixed(2))
      ).toFixed(2)
      let value_4 = (
        max_value *
        (Number(item_4) / 5) *
        Number(bobot_1.toFixed(2))
      ).toFixed(2)
      let value_5 = (
        max_value *
        (Number(item_5) / 5) *
        Number(bobot_1.toFixed(2))
      ).toFixed(2)
      let value_6 = (
        max_value *
        (Number(item_6) / 5) *
        Number(bobot_1.toFixed(2))
      ).toFixed(2)
      let value_7 = (
        max_value *
        (Number(item_7) / 5) *
        Number(bobot_1.toFixed(2))
      ).toFixed(2)
      let value_8 = (
        max_value *
        (Number(item_8) / 10) *
        Number(bobot_2.toFixed(2))
      ).toFixed(2)
      let value_9 = (
        max_value *
        (Number(item_9) / 5) *
        Number(bobot_1.toFixed(2))
      ).toFixed(2)
      let value_10 = (
        max_value *
        (Number(item_10) / 10) *
        Number(bobot_3.toFixed(2))
      ).toFixed(2)
      let value_11 = (
        max_value *
        (Number(item_11) / 5) *
        Number(bobot_1.toFixed(2))
      ).toFixed(2)

      let total =
        Number(value_1) +
        Number(value_2) +
        Number(value_3) +
        Number(value_4) +
        Number(value_5) +
        Number(value_6) +
        Number(value_7) +
        Number(value_8) +
        Number(value_9) +
        Number(value_10) +
        Number(value_11)

      state.bobot_3_1 =
        state.penilaian_grup1_11 != 'N/A' && item_1 >= 0
          ? (bobot_1 * 100).toFixed(2) + '%'
          : '0 %'
      state.bobot_3_2 =
        state.penilaian_grup2_11 != 'N/A' && item_2 >= 0
          ? (bobot_1 * 100).toFixed(2) + '%'
          : '0 %'
      state.bobot_3_3 =
        state.penilaian_grup2_12 != 'N/A' && item_3 >= 0
          ? (bobot_1 * 100).toFixed(2) + '%'
          : '0 %'
      state.bobot_3_4 =
        state.penilaian_grup3_11 != 'N/A' && item_4 >= 0
          ? (bobot_1 * 100).toFixed(2) + '%'
          : '0 %'
      state.bobot_3_5 =
        state.penilaian_grup4_11 != 'N/A' && item_5 >= 0
          ? (bobot_1 * 100).toFixed(2) + '%'
          : '0 %'
      state.bobot_3_6 =
        state.penilaian_grup5_11 != 'N/A' && item_6 >= 0
          ? (bobot_1 * 100).toFixed(2) + '%'
          : '0 %'
      state.bobot_3_7 =
        state.penilaian_grup6_11 != 'N/A' && item_7 >= 0
          ? (bobot_1 * 100).toFixed(2) + '%'
          : '0 %'
      state.bobot_3_8 =
        state.penilaian_grup6_12 != 'N/A' && item_8 >= 0
          ? (bobot_2 * 100).toFixed(2) + '%'
          : '0 %'
      state.bobot_3_9 =
        state.penilaian_grup7_11 != 'N/A' && item_9 >= 0
          ? (bobot_1 * 100).toFixed(2) + '%'
          : '0 %'
      state.bobot_3_10 =
        state.penilaian_grup7_12 != 'N/A' && item_10 >= 0
          ? (bobot_3 * 100).toFixed(2) + '%'
          : '0 %'
      state.bobot_3_11 =
        state.penilaian_grup8_11 != 'N/A' && item_11 >= 0
          ? (bobot_1 * 100).toFixed(2) + '%'
          : '0 %'

      state.value_3_1 =
        state.bobot_3_1 != '0 %' ? Number(value_1).toFixed(2) : 'N/A'
      state.value_3_2 =
        state.bobot_3_2 != '0 %' ? Number(value_2).toFixed(2) : 'N/A'
      state.value_3_3 =
        state.bobot_3_3 != '0 %' ? Number(value_3).toFixed(2) : 'N/A'
      state.value_3_4 =
        state.bobot_3_4 != '0 %' ? Number(value_4).toFixed(2) : 'N/A'
      state.value_3_5 =
        state.bobot_3_5 != '0 %' ? Number(value_5).toFixed(2) : 'N/A'
      state.value_3_6 =
        state.bobot_3_6 != '0 %' ? Number(value_6).toFixed(2) : 'N/A'
      state.value_3_7 =
        state.bobot_3_7 != '0 %' ? Number(value_7).toFixed(2) : 'N/A'
      state.value_3_8 =
        state.bobot_3_8 != '0 %' ? Number(value_8).toFixed(2) : 'N/A'
      state.value_3_9 =
        state.bobot_3_9 != '0 %' ? Number(value_9).toFixed(2) : 'N/A'
      state.value_3_10 =
        state.bobot_3_10 != '0 %' ? Number(value_10).toFixed(2) : 'N/A'
      state.value_3_11 =
        state.bobot_3_11 != '0 %' ? Number(value_11).toFixed(2) : 'N/A'

      state.rating_result_3 = Math.round(total)

      let grand_total =
        Number(state.rating_result_1) +
        Number(state.rating_result_2) +
        Number(total)

      state.total_result = Math.round(grand_total)
    },
    async SET_DOCUMENT_LIST(state, data) {
      state.structurOrgFile = await data.filter(i => i.m_k3l_doc_id == 1)
      state.kebijakanFile = await data.filter(i => i.m_k3l_doc_id == 4)
      state.buktiKebijakanFile = await data.filter(i => i.m_k3l_doc_id == 5)
      state.hiraFile = await data.filter(i => i.m_k3l_doc_id == 6)
      state.policyFile = await data.filter(i => i.m_k3l_doc_id == 7)
      state.riskFile = await data.filter(i => i.m_k3l_doc_id == 8)
      state.implementasiRiskFile = await data.filter(i => i.m_k3l_doc_id == 9)
      state.manualFile = await data.filter(i => i.m_k3l_doc_id == 10)
      state.implementasiManual = await data.filter(i => i.m_k3l_doc_id == 11)
      state.prosedurB3 = await data.filter(i => i.m_k3l_doc_id == 12)
      state.programB3 = await data.filter(i => i.m_k3l_doc_id == 13)
      state.implementasiB3 = await data.filter(i => i.m_k3l_doc_id == 14)
      state.prosedurLimbah = await data.filter(i => i.m_k3l_doc_id == 15)
      state.programLimbah = await data.filter(i => i.m_k3l_doc_id == 16)
      state.buktiPengelolaanLimbah = await data.filter(
        i => i.m_k3l_doc_id == 17
      )
      state.implementasiLimbah = await data.filter(i => i.m_k3l_doc_id == 18)
      state.programFatalPrevention = await data.filter(
        i => i.m_k3l_doc_id == 19
      )
      state.sosialisasiFatalPrevention = await data.filter(
        i => i.m_k3l_doc_id == 20
      )
      state.implementasiFatalPrevention = await data.filter(
        i => i.m_k3l_doc_id == 21
      )
      state.dokumenKerjaFatalPrevention = await data.filter(
        i => i.m_k3l_doc_id == 22
      )
      state.implementasiDokumenKerjaFatalPrevention = await data.filter(
        i => i.m_k3l_doc_id == 23
      )
      state.evaluasiFatalPrevention = await data.filter(
        i => i.m_k3l_doc_id == 24
      )
      state.daftarDokumenKerja = await data.filter(i => i.m_k3l_doc_id == 25)
      state.dokumenKerja = await data.filter(i => i.m_k3l_doc_id == 26)
      state.pemeriksaanImpelentasiDokumenKerja = await data.filter(
        i => i.m_k3l_doc_id == 27
      )
      state.statistikKinerjaK3L = await data.filter(i => i.m_k3l_doc_id == 28)
      state.penyelidikanKecelakaan = await data.filter(
        i => i.m_k3l_doc_id == 29
      )
    },
    async SAVE_DRAFT_VENDOR_INPUT(state, payload) {
      const submitedData = {
        request_id: state.request_id,
        pic_name: state.k3l_pic_name,
        pic_position: state.k3l_pic_position,
        pic_phone: state.k3l_pic_phone,
        pic_phone_code: state.k3l_pic_phone_code,
        pic_email: state.k3l_pic_email,
        group_1_desc: state.textGrup1,
        group_2_desc: state.textGrup2,
        group_22_desc: state.textGrup22,
        group_3_desc: state.textGrup3,
        group_4_desc: state.textGrup4,
        group_5_desc: state.textGrup5,
        group_8_desc: state.textGroup8,
        group_82_desc: state.textGroup82,
        fix_office_pkp2b: state.location_1,
        fix_office_berau: state.location_2,
        fix_office_indo: state.location_3,
        // non_inti: JSON.stringify(state.addedIUJPnonInti),
        // parent_companies: JSON.stringify(state.parent_companies),
        // child_companies: JSON.stringify(state.child_companies),
        // competencies: JSON.stringify(state.addedCompetencies),
        // sistem_manajemen: JSON.stringify(state.addedSistemManajemen),
      }

      if (state.addedGoldenRules && state.addedGoldenRules.length > 0)
        submitedData['golden_rules'] = JSON.stringify(state.addedGoldenRules)

      if (state.addedIUJPnonInti && state.addedIUJPnonInti.length > 0)
        submitedData['non_inti'] = JSON.stringify(state.addedIUJPnonInti)

      state.globalLoading = true
      axios({
        method: 'POST',
        url: `${api_lp}/api/v1/vendor/k3l-draft`,
        data: submitedData,
      })
        .then(async response => {
          state.globalLoading = false

          await payload.onSuccess()
        })
        .catch(error => {
          state.globalLoading = false
          store.commit(
            'SET_NOTIF',
            mixin.methods.$get(error, 'response.data.message', 'Error')
          )
        })
    },
    async SAVE_DRAFT_SIPM_SUBMIT(state, payload) {
      const submitedData = {
        request_id: state.request_id,
        izin_11: state.izin_11,
        izin_12: state.izin_12,
        note_izin_11: state.note_izin_11,
        note_izin_12: state.note_izin_12,
        sertifikat_11: state.sertifikat_11,
        sertifikat_12: state.sertifikat_12,
        sertifikat_13: state.sertifikat_13,
        note_sertifikat_11: state.note_sertifikat_11,
        note_sertifikat_12: state.note_sertifikat_12,
        note_sertifikat_13: state.note_sertifikat_13,
        penilaian_grup1_11: state.penilaian_grup1_11,
        note_grup1_11: state.note_grup1_11,
        penilaian_grup2_11: state.penilaian_grup2_11,
        penilaian_grup2_12: state.penilaian_grup2_12,
        note_grup2_11: state.note_grup2_11,
        note_grup2_12: state.note_grup2_12,
        penilaian_grup3_11: state.penilaian_grup3_11,
        note_grup3_11: state.note_grup3_11,
        penilaian_grup4_11: state.penilaian_grup4_11,
        note_grup4_11: state.note_grup4_11,
        penilaian_grup5_11: state.penilaian_grup5_11,
        note_grup5_11: state.note_grup5_11,
        penilaian_grup6_11: state.penilaian_grup6_11,
        penilaian_grup6_12: state.penilaian_grup6_12,
        note_grup6_11: state.note_grup6_11,
        note_grup6_12: state.note_grup6_12,
        penilaian_grup7_11: state.penilaian_grup7_11,
        penilaian_grup7_12: state.penilaian_grup7_12,
        note_grup7_11: state.note_grup7_11,
        note_grup7_12: state.note_grup7_12,
        penilaian_grup8_11: state.penilaian_grup8_11,
        note_grup8_11: state.note_grup8_11,
        rating_result_1: state.rating_result_1,
        rating_result_2: state.rating_result_2,
        rating_result_3: state.rating_result_3,
        total_result: state.total_result,
        user_id: state.user_id,
      }

      state.globalLoading = true
      axios({
        method: 'POST',
        url: `${api_lp}/api/v1/vendor/k3l-penilaian-draft`,
        data: submitedData,
        // headers: { 'Content-Type': 'multipart/form-data' },
      })
        .then(async response => {
          state.globalLoading = false
          await payload.onSuccess()
        })
        .catch(error => {
          state.globalLoading = false
          store.commit(
            'SET_NOTIF',
            mixin.methods.$get(error, 'response.data.message', 'Error')
          )
        })
    },
    async PROCESSING_K3L(state) {
      const submitedData = {
        request_id: state.request_id,
        pic_name: state.k3l_pic_name,
        pic_position: state.k3l_pic_position,
        pic_phone: state.k3l_pic_phone,
        pic_phone_code: state.k3l_pic_phone_code,
        pic_email: state.k3l_pic_email,
        group_1_desc: state.textGrup1,
        group_2_desc: state.textGrup2,
        group_22_desc: state.textGrup22,
        group_3_desc: state.textGrup3,
        group_4_desc: state.textGrup4,
        group_5_desc: state.textGrup5,
        group_8_desc: state.textGroup8,
        group_82_desc: state.textGroup82,
        fix_office_pkp2b: state.location_1,
        fix_office_berau: state.location_2,
        fix_office_indo: state.location_3,
        golden_rules: JSON.stringify(state.addedGoldenRules),
        non_inti: JSON.stringify(state.addedIUJPnonInti),
        parent_companies: JSON.stringify(state.parent_companies),
        child_companies: JSON.stringify(state.child_companies),
        competencies: JSON.stringify(state.addedCompetencies),
        sistem_manajemen: JSON.stringify(state.addedSistemManajemen),
      }

      state.globalLoading = true
      axios({
        method: 'POST',
        url: `${api_lp}/api/v1/vendor/k3l`,
        data: submitedData,
        // headers: { 'Content-Type': 'multipart/form-data' },
      })
        .then(response => {
          state.globalLoading = false
          state.is_vendor_done = true
          state.is_sipm_approved = true
          store.commit('SET_NOTIF', 'Submit Data K3L Berhasil!')
        })
        .catch(error => {
          state.globalLoading = false
          store.commit(
            'SET_NOTIF',
            mixin.methods.$get(error, 'response.data.message', 'Error')
          )
        })
    },
    async APPROVE_K3L_SIPM(state, payload) {
      const submitedData = {
        request_id: payload.id,
        note: payload.note,
        user_id: payload.user_id,
        pic_name: state.k3l_pic_name,
        pic_position: state.k3l_pic_position,
        pic_phone: state.k3l_pic_phone,
        pic_phone_code: state.k3l_pic_phone_code,
        pic_email: state.k3l_pic_email,
        group_1_desc: state.textGrup1,
        group_2_desc: state.textGrup2,
        group_22_desc: state.textGrup22,
        group_3_desc: state.textGrup3,
        group_4_desc: state.textGrup4,
        group_5_desc: state.textGrup5,
        group_8_desc: state.textGroup8,
        group_82_desc: state.textGroup82,
        fix_office_pkp2b: state.location_1,
        fix_office_berau: state.location_2,
        fix_office_indo: state.location_3,
        golden_rules: JSON.stringify(state.addedGoldenRules),
        non_inti: JSON.stringify(state.addedIUJPnonInti),
        parent_companies: JSON.stringify(state.parent_companies),
        child_companies: JSON.stringify(state.child_companies),
        competencies: JSON.stringify(state.addedCompetencies),
        sistem_manajemen: JSON.stringify(state.addedSistemManajemen),
      }

      state.globalLoading = true
      axios({
        method: 'POST',
        url: `${api}/api/v1/request/approve-k3l-sipm/${submitedData.request_id}`,
        data: submitedData,
        // headers: { 'Content-Type': 'multipart/form-data' },
      })
        .then(response => {
          state.globalLoading = false
          state.is_sipm_approved = true
          store.commit('SET_NOTIF', response.data.message)
        })
        .catch(error => {
          state.globalLoading = false
          store.commit(
            'SET_NOTIF',
            mixin.methods.$get(error, 'response.data.message', 'Error')
          )
        })
    },
    async SUBMIT_PENILAIAN(state) {
      const submitedData = {
        request_id: state.request_id,
        izin_11: state.izin_11,
        izin_12: state.izin_12,
        note_izin_11: state.note_izin_11,
        note_izin_12: state.note_izin_12,
        sertifikat_11: state.sertifikat_11,
        sertifikat_12: state.sertifikat_12,
        sertifikat_13: state.sertifikat_13,
        note_sertifikat_11: state.note_sertifikat_11,
        note_sertifikat_12: state.note_sertifikat_12,
        note_sertifikat_13: state.note_sertifikat_13,
        penilaian_grup1_11: state.penilaian_grup1_11,
        note_grup1_11: state.note_grup1_11,
        penilaian_grup2_11: state.penilaian_grup2_11,
        penilaian_grup2_12: state.penilaian_grup2_12,
        note_grup2_11: state.note_grup2_11,
        note_grup2_12: state.note_grup2_12,
        penilaian_grup3_11: state.penilaian_grup3_11,
        note_grup3_11: state.note_grup3_11,
        penilaian_grup4_11: state.penilaian_grup4_11,
        note_grup4_11: state.note_grup4_11,
        penilaian_grup5_11: state.penilaian_grup5_11,
        note_grup5_11: state.note_grup5_11,
        penilaian_grup6_11: state.penilaian_grup6_11,
        penilaian_grup6_12: state.penilaian_grup6_12,
        note_grup6_11: state.note_grup6_11,
        note_grup6_12: state.note_grup6_12,
        penilaian_grup7_11: state.penilaian_grup7_11,
        penilaian_grup7_12: state.penilaian_grup7_12,
        note_grup7_11: state.note_grup7_11,
        note_grup7_12: state.note_grup7_12,
        penilaian_grup8_11: state.penilaian_grup8_11,
        note_grup8_11: state.note_grup8_11,
        rating_result_1: state.rating_result_1,
        rating_result_2: state.rating_result_2,
        rating_result_3: state.rating_result_3,
        total_result: state.total_result,
        user_id: state.user_id,
      }

      function checkForm() {
        const listPenilaian = [
          [state.izin_11, `IUJP / SIUP: Dokument Perusahaan, Item 1.1`],
          [state.izin_12, `IUJP / SIUP: Dokument Perusahaan, Item 1.2`],
          [
            state.sertifikat_11,
            `Kompetensi Umum: Dokument Perusahaan, Item 1.1`,
          ],
          [
            state.sertifikat_12,
            `Kompetensi khusus: Dokument Perusahaan, Item 1.1`,
          ],
          [
            state.sertifikat_13,
            `Kompetensi khusus: Dokument Perusahaan, Item 1.2`,
          ],
          [
            state.penilaian_grup1_11,
            `Kebijakan, Kepemimpinan dan Komitmen: Grup 1-3, Item 1.1`,
          ],
          [state.penilaian_grup2_11, `Manajemen Resiko: Grup 1-3, Item 1.1`],
          [state.penilaian_grup2_12, `Manajemen Resiko: Grup 1-3, Item 1.2`],
          [state.penilaian_grup3_11, `Manual K3L: Grup 1-3, Item 1.2`],
          [state.penilaian_grup4_11, `Pengelolaan B3: Grup 4-6, Item 1.1`],
          [state.penilaian_grup5_11, `Pengelolaan Limbah: Grup 4-6, Item 1.1`],
          [
            state.penilaian_grup6_11,
            `Pencegahan Kecelakaan Fatal ( Golden Rules ): Grup 4-6, Item 1.1`,
          ],
          [
            state.penilaian_grup6_12,
            `Pencegahan Kecelakaan Fatal ( Golden Rules ): Grup 4-6, Item 1.2`,
          ],
          [
            state.penilaian_grup7_11,
            `Sertifikasi Sistem Manajemen: Grup 7-8, Item 1.1`,
          ],
          [
            state.penilaian_grup7_12,
            `Sertifikasi Sistem Manajemen: Grup 7-8, Item 1.2`,
          ],
          [state.penilaian_grup8_11, `Kinerja K3L: Grup 7-8, Item 1.1`],
        ]

        return mixin.methods.multiConditions(listPenilaian)
      }

      if (checkForm()) {
        state.globalLoading = true
        axios({
          method: 'POST',
          url: `${api_lp}/api/v1/vendor/k3l-penilaian`,
          data: submitedData,
          // headers: { 'Content-Type': 'multipart/form-data' },
        })
          .then(response => {
            state.globalLoading = false
            state.is_oc_submit = true
            state.is_preview = true
            store.commit('SET_NOTIF', 'Submit Data K3L Berhasil!')
          })
          .catch(error => {
            state.globalLoading = false
            store.commit(
              'SET_NOTIF',
              mixin.methods.$get(error, 'response.data.message', 'Error')
            )
          })
      } else {
        // do nothing
      }
    },
    async APPROVE_HOC(state) {
      try {
        state.globalLoading = true
        const { data } = await axios({
          method: 'POST',
          url: `${api}/api/v1/request/approve-hoc/${state.request_id}`,
          data: {
            note: '',
            user_id: state.user_id,
          },
        })

        if (data && data.status == 'success') {
          state.globalLoading = false
          state.is_k3l_done = true
          store.commit('SET_NOTIF', data.message)
        }
      } catch (error) {
        state.globalLoading = false
        store.commit(
          'SET_NOTIF',
          mixin.methods.$get(error, 'response.data.message', 'Error')
        )
      }
    },
  },
}

export default k3lStore
